<template>
  <div>
    <v-lazy
      v-model="isActive"
      :options="{
        threshold: 0.5
      }"
      min-height="200"
      transition="fade-transition"
    >
      <section-about />
    </v-lazy>
    <v-lazy
      v-model="isActive"
      :options="{
        threshold: 0.5
      }"
      min-height="200"
      transition="fade-transition"
    >
      <section-service />
    </v-lazy>
    <v-lazy
      v-model="isActive"
      :options="{
        threshold: 0.5
      }"
      min-height="200"
      transition="fade-transition"
    >
      <section-equipos />
    </v-lazy>
    <v-lazy
      v-model="isActive"
      :options="{
        threshold: 0.5
      }"
      min-height="200"
      transition="fade-transition"
    >
      <banner-msj />
    </v-lazy>
    <v-lazy
      v-model="isActive"
      :options="{
        threshold: 0.5
      }"
      min-height="200"
      transition="fade-transition"
    >
      <section-clientes :loading="loading" />
    </v-lazy>
    <v-lazy
      v-model="isActive"
      :options="{
        threshold: 0.5
      }"
      min-height="200"
      transition="fade-transition"
    >
      <section-obras />
    </v-lazy>
    <v-lazy
      v-model="isActive"
      :options="{
        threshold: 0.5
      }"
      min-height="200"
      transition="fade-transition"
    >
      <section-contact />
    </v-lazy>

    <!-- <tilt-bottom-divider /> -->
  </div>
</template>

<script>
export default {
  data: () => ({
    loading: true,
    colorAvatar: "primary",
    colorIcon: "white",
    isActive: false
  }),
  components: {
    BannerMsj: () => import("@/components/banner/BannerMsj.vue"),
    SectionAbout: () => import("@/views/About/Index.vue"),
    SectionService: () => import("@/views/Service/Index.vue"),
    SectionEquipos: () => import("@/views/Equipos/Index.vue"),
    SectionClientes: () => import("@/views/Clientes/Index.vue"),
    SectionObras: () => import("@/views/Obras/Index.vue"),
    SectionContact: () => import("@/views/Contact/Index.vue")
  },
  methods: {
    loadingImg() {
      setTimeout(() => {
        this.loading = false;
      }, 5000);
    }
  },
  created() {
    this.loadingImg();
  }
};
</script>
